import * as React from "react";
import * as ReactDOM from "react-dom";
import { Navigation, NavigationItem, NavigationSeparator } from "../../components/navigation";
import { IUser } from "../../models/get";
import { getCurrentUserAsync } from "../../globals";

interface IProperties
{
    selected: "calendargroups" |
    "calendars" |
    "cementeries" |
    "gravetypes" |
    "labels" |
    "subjects" |
    "status" |
    "displaytypes" |
    "burialmethods" |
    "mourninghalls" |
    "persontypes" |
    "morticians" |
    "pastors" |
    "denominations" |
    "usergroups" |
    "users" |
    "reports" |
    "apiclients" |
    "notifications" |
    "others" |
    "help"
    
}

interface IState
{
    user?: IUser
}

export default class SettingsNav extends React.Component<IProperties, IState>
{
    /**
     * Erstellt eine neue Instanz der Klasse @see SettingsNav.
     * @param props Alle gesetzten Eigenschaften.
     */
    constructor(props: IProperties)
    {
        super(props);
        this.state = {};
    }

    async componentDidMount()
    {
        const user: IUser = await getCurrentUserAsync();
        this.setState({
            user: user
        });
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { selected } = this.props;
        const { user } = this.state;

        if (user == null)
            return null;

        return (
            <Navigation direction="vertical">
                <NavigationItem
                    text="Kalendergruppen"
                    isSelected={selected === "calendargroups"}
                    linkTo={selected === "calendargroups" ? null : "/settings/calendargroups"}
                    isDisabled={!user.claims.can_see_setting_calendargroups}
                />
                <NavigationItem
                    text="Kalender"
                    isSelected={selected === "calendars"}
                    linkTo={selected === "calendars" ? null : "/settings/calendars"}
                    isDisabled={!user.claims.can_see_setting_calendars}
                />
                <NavigationItem
                    text="Friedhöfe"
                    isSelected={selected === "cementeries"}
                    linkTo={selected === "cementeries" ? null : "/settings/cementeries"}
                    isDisabled={!user.claims.can_see_setting_cementeries}
                />
                <NavigationItem
                    text="Grabarten"
                    isSelected={selected === "gravetypes"}
                    linkTo={selected === "gravetypes" ? null : "/settings/gravetypes"}
                    isDisabled={!user.claims.can_see_setting_gravetypes}
                />
                <NavigationSeparator />
                <NavigationItem
                    text="Labels"
                    isSelected={selected === "labels"}
                    linkTo={selected === "labels" ? null : "/settings/labels"}
                    isDisabled={!user.claims.can_see_setting_labels}
                />
                <NavigationItem
                    text="Betreffzeilen"
                    isSelected={selected === "subjects"}
                    linkTo={selected === "subjects" ? null : "/settings/subjects"}
                    isDisabled={!user.claims.can_see_setting_subjects}
                />
                <NavigationItem
                    text="Status"
                    isSelected={selected === "status"}
                    linkTo={selected === "status" ? null : "/settings/status"}
                    isDisabled={!user.claims.can_see_setting_status}
                />
                <NavigationItem
                    text="Anzeigearten"
                    isSelected={selected === "displaytypes"}
                    linkTo={selected === "displaytypes" ? null : "/settings/displaytypes"}
                    isDisabled={!user.claims.can_see_setting_displaytypes}
                />
                <NavigationItem
                    text="Bestattungsarten"
                    isSelected={selected === "burialmethods"}
                    linkTo={selected === "burialmethods" ? null : "/settings/burialmethods"}
                    isDisabled={!user.claims.can_see_setting_burialmethods}
                />
                <NavigationItem
                    text="Trauerhallen"
                    isSelected={selected === "mourninghalls"}
                    linkTo={selected === "mourninghalls" ? null : "/settings/mourninghalls"}
                    isDisabled={!user.claims.can_see_setting_mourninghalls}
                />
                <NavigationSeparator />
                <NavigationItem
                    text="Personenarten"
                    isSelected={selected === "persontypes"}
                    linkTo={selected === "persontypes" ? null : "/settings/persontypes"}
                    isDisabled={!user.claims.can_see_setting_persontypes}
                />
                <NavigationItem
                    text="Bestatter"
                    isSelected={selected === "morticians"}
                    linkTo={selected === "morticians" ? null : "/settings/morticians"}
                    isDisabled={!user.claims.can_see_setting_morticians}
                />
                <NavigationItem
                    text="Pfarrer"
                    isSelected={selected === "pastors"}
                    linkTo={selected === "pastors" ? null : "/settings/pastors"}
                    isDisabled={!user.claims.can_see_setting_pastors}
                />
                <NavigationItem
                    text="Konfessionen"
                    isSelected={selected === "denominations"}
                    linkTo={selected === "denominations" ? null : "/settings/denominations"}
                    isDisabled={!user.claims.can_see_setting_denominations}
                />
                <NavigationSeparator />
                <NavigationItem
                    text="Benutzergruppen"
                    isSelected={selected === "usergroups"}
                    linkTo={selected === "usergroups" ? null : "/settings/usergroups"}
                    isDisabled={!user.claims.can_see_setting_usergroups}
                />
                <NavigationItem
                    text="Benutzer"
                    isSelected={selected === "users"}
                    linkTo={selected === "users" ? null : "/settings/users"}
                    isDisabled={!user.claims.can_see_setting_users}
                />
                <NavigationSeparator />
                <NavigationItem
                    text="Reports"
                    isSelected={selected === "reports"}
                    linkTo={selected === "reports" ? null : "/settings/reports"}
                    isDisabled={!user.claims.can_see_setting_reports}
                />
                <NavigationSeparator />
                <NavigationItem
                    text="API"
                    isSelected={selected === "apiclients"}
                    linkTo={selected === "apiclients" ? null : "/settings/apiclients"}
                    isDisabled={!user.claims.can_see_setting_api}
                />
                <NavigationItem
                    text="Benachrichtigungen"
                    isSelected={selected === "notifications"}
                    linkTo={selected === "notifications" ? null : "/settings/notifications"}
                    isDisabled={!user.claims.can_see_setting_notifications}
                />
                <NavigationItem
                    text="Sonstiges"
                    isSelected={selected === "others"}
                    linkTo={selected === "others" ? null : "/settings/others"}
                    isDisabled={!user.claims.can_see_setting_others}
                />
                <NavigationSeparator />
                <NavigationItem
                    text="Hilfe"
                    isSelected={selected === "help"}
                    linkTo={selected === "help" ? null : "/settings/help"}
                    isDisabled={!user.claims.can_see_setting_help}
                />
            </Navigation>
        );
    }
}